import { useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import logo from "@/assets/logo-horizontal-orange.svg"
import { Button } from "@/components/ui/button"

const NotFound = () => {
  const location = useLocation()

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname)
  }, [location.pathname])

  const homePath = localStorage.getItem("token") ? "/dashboard" : "/login"

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[url('/src/assets/background-grain.png')] bg-cover bg-center bg-no-repeat p-6">
      <div className="z-20 w-full max-w-md space-y-8 text-center">

        <div className="space-y-4 rounded-l border p-8">
          <p className="font-display text-9xl italic text-orange-500">Ops...</p>
          <h1 className="text-xl text-foreground">
            O endereço acessado não existe.
          </h1>

          <Button
            asChild
            className="mt-4 w-full"
          >
            <Link to={homePath}>Voltar ao início</Link>
          </Button>
        </div>
          <p className="text-xs italic text-muted-foreground">
            error 404 - Página não encontrada
          </p>
      </div>

      <div className="absolute size-[500px] animate-ripple rounded-full border-[10px] border-white blur-[30px] transition-opacity"></div>
      <div className="absolute size-[1000px] animate-ripple rounded-full border-[10px] border-white blur-[40px] transition-opacity [animation-delay:.5s]"></div>
      <div className="absolute size-[1800px] animate-ripple rounded-full border-[10px] border-white blur-[50px] transition-opacity [animation-delay:.7s]"></div>
    </div>
  )
}

export default NotFound
